function contains(appName) {
	if (!navigator || !navigator.userAgent) {
		return false;
	}
	return navigator.userAgent.includes(appName);
}

export default { contains };
